import React, { ReactNode, useEffect } from "react";

import CircleBadge from "../CircleBadge";

import * as styledElements from "./ModalContentWithCloseButtonStyles";

const ModalContentWithCloseButton = ({
  children,
  closeModal,
  title,
  lessPadding,
  fullScreen,
  showCloseHint,
}: {
  children: ReactNode;
  closeModal: () => void;
  title?: string;
  lessPadding?: boolean;
  fullScreen?: boolean;
  showCloseHint?: boolean;
}) => {
  useEffect(() => {
    // Prevents background from scrolling when modal is open
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const circleBadge = (
    <CircleBadge
      iconProps={{
        src: "/icons/cancel.svg",
        alt: "cancel",
      }}
      onClick={closeModal}
    />
  );

  return (
    <styledElements.Container lessPadding={lessPadding} fullScreen={fullScreen}>
      <styledElements.Header>
        <styledElements.Title>{title}</styledElements.Title>
        {showCloseHint ? (
          <>
            <styledElements.CloseHint>
              Press (Esc) to close
            </styledElements.CloseHint>
            <styledElements.CloseBadge>{circleBadge}</styledElements.CloseBadge>
          </>
        ) : (
          circleBadge
        )}
      </styledElements.Header>
      <styledElements.Content>{children}</styledElements.Content>
    </styledElements.Container>
  );
};

export default ModalContentWithCloseButton;
